/**
 * Servicio que conecta con la API las inspecciones de las incidencias
 */
TareasService.$inject = ['$resource'];
export default function TareasService($resource) {
    var urlBase = Sigo.var.path + '/api/v1' + '/tareas' + '/:tareaId';

    return $resource(urlBase, {
            tareaId: '@tareaId'
        }, {
            'edit': {method: 'GET', url: urlBase + '/edit'},
            'update': {method: 'PUT'}
        }
    );
}